import Swal from "sweetalert2";
import api from "./api";
import { LayoutRemessaRetornoDto } from "../shared/dtos/LayoutRemessaRetorno.dto";



class LayoutRemessaRetornoService {
  async getAllLayoutRemessaRetorno(): Promise<LayoutRemessaRetornoDto[]> {
    return api
      .get("/layout-remessa-retorno/find-all")
      .then((response) => {
        return Promise.resolve(response.data as LayoutRemessaRetornoDto[]);
      })
      .catch((error) => {
        this.handleError(error, `Erro ao buscar lotações`);
        return Promise.reject(error);
      });
  }


  private handleError(error: any, message: string): void {
    if (error.response) {
      Swal.fire({
        title: "Erro",
        text: `${message}: ${error.response.data}`,
        icon: "error",
        confirmButtonText: "Fechar",
        allowOutsideClick: false,
      });
    } else {
      Swal.fire({
        title: "Erro",
        text: `${message}: ${error.message || "Erro desconhecido"}`,
        icon: "error",
        confirmButtonText: "Fechar",
        allowOutsideClick: false,
      });
    }
  }
}

const layoutRemessaRetornoService = new LayoutRemessaRetornoService();
export default layoutRemessaRetornoService;
